import React, { useState, useEffect } from 'react';
import './CellArrivalAnimation.css';

const CellArrivalAnimation = ({ trigger, children }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (trigger) {
      setIsAnimating(true);
      
      // Generate dust particles with random positions and delays
      const newParticles = Array(12).fill(null).map((_, i) => ({
        id: i,
        angle: (i * 30) + (Math.random() * 20 - 10), // Spread around circle with some randomness
        delay: Math.random() * 0.2, // Random delay up to 200ms
        duration: 0.6 + Math.random() * 0.4, // Duration 600-1000ms
      }));
      setParticles(newParticles);

      // Reset animation after completion
      const animationTimer = setTimeout(() => {
        setIsAnimating(false);
        setParticles([]);
      }, 1200); // Total animation duration

      return () => clearTimeout(animationTimer);
    }
  }, [trigger]);

  return (
    <div className={`cell-arrival-container ${isAnimating ? 'animating' : ''}`}>
      {/* Main cell content with shake animation */}
      <div className={`cell-content ${isAnimating ? 'shake' : ''}`}>
        {children}
      </div>

      {/* Dust particles */}
      {isAnimating && particles.map(particle => (
        <div
          key={particle.id}
          className="dust-particle"
          style={{
            '--angle': `${particle.angle}deg`,
            '--delay': `${particle.delay}s`,
            '--duration': `${particle.duration}s`,
          }}
        />
      ))}

      {/* Impact wave effect */}
      {isAnimating && (
        <div className="impact-wave" />
      )}

      {/* Glow effect */}
      {isAnimating && (
        <>
          <div className="arrival-glow" />
          <div className="center-flash" />
        </>
      )}
    </div>
  );
};

export default CellArrivalAnimation;